module.exports = __webpack_public_path__ + "media/right-music.8788d659.mp3";